import { BookingStatus } from "enums";
import { getGlobalDateTimeFilter } from "services";
import lang from "translations";

export const statusFilter = [
  { text: lang.confirmed, value: BookingStatus.CONFIRMED },
  { text: lang.toBeCheckedIn, value: BookingStatus.TO_BE_CHECKED_IN },
  { text: lang.missedCheckIn, value: BookingStatus.MISSED_CHECK_IN },
  { text: lang.toBeCheckedOut, value: BookingStatus.TO_BE_CHECKED_OUT },
  { text: lang.missedCheckOut, value: BookingStatus.MISSED_CHECK_OUT },
  { text: lang.checkedIn, value: BookingStatus.CHECKED_IN },
  { text: lang.checkedOut, value: BookingStatus.CHECKED_OUT },
  { text: lang.cancelled, value: BookingStatus.CANCELLED },
];

export const bookingListFilterState = (venueId) => {
  const dateTime = getGlobalDateTimeFilter();
  return {
    venueId,
    searchKey: "",
    statusList: [],
    pageable: true,
    page: 1,
    pageSize: 20,
    dateRange: [dateTime[0], dateTime[1]],
    startDateTime: null,
    endDateTime: null,
  };
};
